import React from 'react'
import './CSS/Last.css'
function Footer() {
  return (
    <>

<div className='footer'>
      
            <p>Created by <span> Abhi </span> with lots of love. <span> c</span> Copyrights, All rights reserved</p>
            
   <div className='awes'>
   <a href='https://github.com/githubabhi08'><i class="fa-brands fa-square-github"></i></a>
   
   </div>
    </div>
    
    </>
  )
}

export default Footer